import axios from "axios";
import { getAccessToken } from "../Login/Service/LoginService";
import { SERVER_URL } from "./app.config";


const FallbackErrorMessage = "Something went wrong! Please try again after some time";
const EmptyResponseMessage = "Empty Response Received from the Server";

const defaultHeaders = {
	Accept: "application/json",
	"Content-Type": "application/json;charset=UTF-8",
};

//Axios does not support body for GET requests
export const get = async (config) => {
	let { url, headers, params, data, customBaseUrl } = config;

	if(customBaseUrl) url = customBaseUrl + url;
	else url = SERVER_URL + url

	if (data) {
		console.warn("Sending Data through GET Request is prohibited");
	}

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		const accessToken = await getAccessToken();

		if (!accessToken) {
			console.log("FAiled to Fetch Access Token");
			return { error: "Failed to Fetch Access Token" };
		}

		defaultHeaders["Xook-Access-Token"] = accessToken;

		const options = {
			url: url,
			method: "get",
			params: params,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);
		// const { data: { data: responseData }, status } = response;
		// if (!responseData) {
		// 	console.error(EmptyResponseMessage, url);
		// 	return { error: EmptyResponseMessage };
		// }
		return {
			data: response.data.data,
		};

	} catch (error) {
		console.log(error);
		return {
			error: error?.response?.data?.message || FallbackErrorMessage,
		};
	}
};

export const post = async (config) => {
	let { url, headers, data } = config;

	url = SERVER_URL + url

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		const accessToken = await getAccessToken();

		if (!accessToken) {
			return { error: "Failed to Fetch Access Token" };
		}

		defaultHeaders["Xook-Access-Token"] = accessToken;

		const options = {
			url: url,
			method: "post",
			data: data,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);
		const { data: { data: responseData }, status } = response;
		if (!responseData) {
			console.error(EmptyResponseMessage, url);
			return { error: EmptyResponseMessage };
		}
		return {
			data: responseData,
			status,
		};
		
	} catch (error) {
		console.log(error);
		return {
			error: error?.response?.data?.message || FallbackErrorMessage,
		};
	}
};

export const patch = async (config) => {
	var { url, headers, data } = config;

	url = SERVER_URL + url

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		const accessToken = await getAccessToken();

		if (!accessToken) {
			return { error: "Failed to Fetch Access Token" };
		}

		defaultHeaders["Xook-Access-Token"] = accessToken;

		const options = {
			url: url,
			method: "patch",
			data: data,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);
		const { data: { data: responseData }, status } = response;
		if (!responseData) {
			console.error(EmptyResponseMessage, url);
			return { error: EmptyResponseMessage };
		}
		return {
			data: responseData,
			status,
		};
		
	} catch (error) {
		console.log(error);
		return {
			error: error?.response?.data?.message || FallbackErrorMessage,
		};
	}
};

export const put = async (config) => {
	var { url, headers, data } = config;

	url = SERVER_URL + url

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		const accessToken = await getAccessToken();

		if (!accessToken) {
			return { error: "Failed to Fetch Access Token" };
		}

		defaultHeaders["Xook-Access-Token"] = accessToken;

		const options = {
			url: url,
			method: "put",
			data: data,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);
		const { data: { data: responseData }, status } = response;
		if (!responseData) {
			return { error: EmptyResponseMessage };
		}
		return {
			data: responseData,
			status,
		};
		
	} catch (error) {
		console.log(error);
		return {
			error: error?.response?.data?.message || FallbackErrorMessage,
		};
	}
};

export const deleteApi = async (config) => {
	var { url, headers, data } = config;

	url = SERVER_URL + url

	try {
		//Returns the current access token if it has not expired or it will not expire for the next 5 mins
		//If the access token is expired or is expiring it will refresh and send a new token
		//Can be given a param forceRefresh to forcefully refresh the token everytime
		const accessToken = await getAccessToken();

		if (!accessToken) {
			return { error: "Failed to Fetch Access Token" };
		}

		defaultHeaders["Xook-Access-Token"] = accessToken;

		const options = {
			url: url,
			method: "delete",
			data: data,
			headers: headers ? Object.assign(headers, defaultHeaders) : defaultHeaders,
		};

		const response = await axios(options);
		const { data: { data: responseData }, status } = response;
		if (!responseData) {
			console.error(EmptyResponseMessage, url);
			return { error: EmptyResponseMessage };
		}
		return {
			data: responseData,
			status,
		};
		
	} catch (error) {
		console.log(error);
		return {
			error: error?.response?.data?.message || FallbackErrorMessage,
		};
	}
};

export const getApi = async function(a = "",b = "", c = "", d = "", e = "", f = "", g = "") {
	return new Promise((resolve,reject) => {
		setTimeout(() => resolve(true), 1000);
	})
}

export const postApi = async function(a = "",b = "", c = "", d = "", e = "", f = "", g = "") {
	return new Promise((resolve,reject) => {
		setTimeout(() => resolve(true), 1000);
	})
}

export const patchApi = async function(a = "",b = "", c = "", d = "", e = "", f = "", g = "") {
	return new Promise((resolve,reject) => {
		setTimeout(() => resolve(true), 1000);
	})
}
